import { z } from 'zod';

// Native <select> writes strings into form state ('' when the placeholder is selected, '42' when an
// option is picked). Normalize '' / null / undefined → null, otherwise the numeric id.
const optionalIdFromSelect = z.unknown().transform((v): number | null => {
  if (v === '' || v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
});

const baseSchema = z.object({
  competition_type_id: optionalIdFromSelect,
  weight_class_id: optionalIdFromSelect,
  category_id: optionalIdFromSelect,
  person_id: z.number(),
  team_id: optionalIdFromSelect,
  is_reserve: z.boolean().default(false),
});

/**
 * Validation differs by competition kind:
 * - Team competitions: a lifter is registered by team alone (no registration category), so the team
 *   is the only required selector.
 * - Regular competitions: the registration category (tävlingstyp + ålderskategori) stays required,
 *   and there is no team to pick.
 */
export function makeRegisterLifterSchema(isTeamComp: boolean) {
  return baseSchema.superRefine((value, ctx) => {
    if (isTeamComp) {
      if (value.team_id == null) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['team_id'], message: 'Välj lag' });
      }
      return;
    }

    if (value.competition_type_id == null) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['competition_type_id'], message: 'Välj tävlingstyp' });
    }
    if (value.category_id == null) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['category_id'], message: 'Välj kategori' });
    }
  });
}

export type Schema = z.infer<typeof baseSchema>;
export type SchemaInput = z.input<typeof baseSchema>;
